// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1518":"0fc8075923b17af0","9480":"4ac7ae8f5e128fe9"}[chunkId] + ".css";
};